<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <h2>Vehicle Search</h2>
      </div>
      <div class="col-lg-12">
        <card>
          <h4 class="card-title">Please fill in the data</h4>
          <form class="form-horizontal">
            <div class="row" style="margin-bottom: 1%">
              <label class="col-sm-2 col-form-label">Select Date</label>
              <div class="col-sm-9">
                <el-date-picker
                  v-model="datePicker"
                  type="daterange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                ></el-date-picker>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">Vehicle No</label>
              <div class="col-sm-9">
                <base-input placeholder="Enter Vehicle No" v-model="vehregno">
                  <span
                    slot="helpBlock"
                    class="form-text"
                  >A block of help text that breaks onto a new line.</span>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 mr-auto ml-auto">
                <base-button @click="search()" type="primary">Search</base-button>
              </div>
            </div>
          </form>
        </card>
      </div>
      <div class="col-lg-12">
        <hr />
      </div>
      <div class="col-lg-6">
        <card type="chart">
          <template slot="header">
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Availability</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="availableChart.loaded"
              :chart-data="availableChart.chartData"
              :gradient-colors="availableChart.gradientColors"
              :gradient-stops="availableChart.gradientStops"
              :extra-options="availableChart.extraOptions"
              :height="200"
            ></line-chart>
          </div>
        </card>
      </div>
      <div class="col-lg-6">
        <card type="chart">
          <template slot="header">
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Breakdown</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="breakdownChart.loaded"
              :chart-data="breakdownChart.chartData"
              :gradient-colors="breakdownChart.gradientColors"
              :gradient-stops="breakdownChart.gradientStops"
              :extra-options="breakdownChart.extraOptions"
              :height="200"
            ></line-chart>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { DatePicker } from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    LineChart,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      activeName: "first",
      datePicker: "",
      vehregno: "",
      // Red Line Chart
      breakdownChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Breakdown",
              fill: true,
              borderColor: "rgba(237, 28, 36, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(237, 28, 36, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0]
            }
          ]
        },
        loaded: true,
        extraOptions: chartConfigs.binaryOptions,
        gradientColors: [
          "rgba(237, 28, 36, 0.0)",
          "rgba(237, 28, 36, 0.0)",
          "rgba(237, 28, 36, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      // Green Line Chart
      availableChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Availability",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0]
            }
          ]
        },
        loaded: true,
        extraOptions: chartConfigs.binaryOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      }
    };
  },

  methods: {
    search() {
      let start = moment(this.datePicker[0]).unix();
      let end = moment(this.datePicker[1]).unix();
      if (this.vehregno == "") {
        swal({
          title: "Please enter Vehicle No!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Okay!",
          buttonsStyling: false
        });
      } else {
        this.availableChart.loaded = false;
        this.breakdownChart.loaded = false;
        console.log(start, end);
        console.log(this.vehregno);
        this.$http
          .get(`:9993/api/v1/search/${this.vehregno}/${start}/${end}`)
          .then(res => {
            if (!res.error) {
              let data = res.message;
              console.log(data)
              
              let date = []
              let breakdowndata = []
              let availabilitydata = []
              for(var i=0; i<data.length; i++){
                date.push(moment(data[i].Date).format("YYYY-MM-DD"))

                if(data[i].StatusID == ""){
                  availabilitydata.push(null)
                  breakdowndata.push(null)
                } else if(data[i].StatusID == "1") {
                  availabilitydata.push(1)
                  breakdowndata.push(null)
                } else if (data[i].StatusID == "0"){
                  availabilitydata.push(null)
                  breakdowndata.push(1)
                }

              }
              // Red Line Chart
              let breakdown = {
                chartData: {
                  labels: date,
                  datasets: [
                    {
                      label: "Breakdown",
                      fill: true,
                      borderColor: "rgba(237, 28, 36, 1)",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      pointBackgroundColor: "rgba(237, 28, 36, 1)",
                      pointBorderColor: "rgba(255,255,255,0)",
                      pointHoverBackgroundColor: "#be55ed",
                      pointBorderWidth: 20,
                      pointHoverRadius: 4,
                      pointHoverBorderWidth: 15,
                      pointRadius: 4,
                      data: breakdowndata
                    }
                  ]
                },
                loaded: true,
                extraOptions: chartConfigs.binaryOptions,
                gradientColors: [
                  "rgba(237, 28, 36, 0.0)",
                  "rgba(237, 28, 36, 0.0)",
                  "rgba(237, 28, 36, 0.0)"
                ],
                gradientStops: [1, 0.4, 0]
              };
              let available = {
                chartData: {
                  labels: date,
                  datasets: [
                    {
                      label: "Availability",
                      fill: true,
                      borderColor: "rgba(94, 170, 30, 1)",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      pointBackgroundColor: "rgba(94, 170, 30, 1)",
                      pointBorderColor: "rgba(255,255,255,0)",
                      pointHoverBackgroundColor: "#be55ed",
                      pointBorderWidth: 20,
                      pointHoverRadius: 4,
                      pointHoverBorderWidth: 15,
                      pointRadius: 4,
                      data: availabilitydata
                    }
                  ]
                },
                loaded: true,
                extraOptions: chartConfigs.binaryOptions,
                gradientColors: [
                  "rgba(94, 170, 30, 0.0)",
                  "rgba(94, 170, 30, 0.0)",
                  "rgba(94, 170, 30, 0.0)"
                ],
                gradientStops: [1, 0.4, 0]
              };

              this.availableChart = available;
              this.breakdownChart = breakdown;
            } else {
              this.availableChart.loaded = true;
              this.breakdownChart.loaded = true;
              swal({
                title: res.message,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: "Okay!",
                buttonsStyling: false
              });
            }
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
label {
  font-weight: bold;
}
.card-title > b {
  color: #99e6ff;
}
</style>
